import React, { useState } from "react";
import {
  Pressable,
  StyleSheet,
  Text,
  useWindowDimensions,
  View,
} from "react-native";
import DashboardHeader from "../components/DashboardHeader";
import AuthService from "../services/auth";
import { RootStackScreenProps } from "../types";

import { RootState } from "../services/store/app";
import { useSelector } from "react-redux";
import { colors } from "../components/Shared";
import UserViewComponent from "../components/settings/UserViewComponent";
import PositionView from "../components/settings/position/View";
import ResourceView from "../components/settings/resource/View";
import CreateResource from "../components/settings/resource/Create";
import CreatePosition from "../components/settings/position/Create";

const authService = new AuthService();

export default function SettingsScreen({
  navigation,
}: RootStackScreenProps<"Settings">) {
  const common = useSelector((state: RootState) => state.commonReducer);
  const isAdmin = common.user.roll > 0;
  const window = useWindowDimensions();

  const [view, setView] = useState<"user" | "position" | "createPosition" | "resource" | "createResource">("user");

  return (
    <View style={styles.container}>
      <DashboardHeader
        onBack={() => navigation.navigate("DashBoard")}
        onPressSettings={() => navigation.navigate("DashBoard")}
        isAdmin={isAdmin}
      />
      <View style={styles.content}>
        <View
          style={{
            width: window.width > 699 ? 350 : "100%",
            borderRightWidth: 1,
            borderRightColor: "#c4c4c4",
            flexDirection: "column",
          }}
        >
          <Pressable style={styles.item} onPress={() => setView("user")}>
            <Text style={styles.itemText}>Users</Text>
          </Pressable>

          <Pressable style={styles.item} onPress={() => setView("position")}>
            <Text style={styles.itemText}>Positions</Text>
          </Pressable>

          <Pressable style={styles.item} onPress={() => setView("resource")}>
            <Text style={styles.itemText}>Resources</Text>
          </Pressable>
        </View>

        <View style={{ flex: 1 }}>
          {view === 'user' && <UserViewComponent />}

          {view === "position" && <PositionView onCreate={() => setView("createPosition")} />}
          {view === "createPosition" && <CreatePosition onBack={() => setView("position")} />}

          {view === "resource" && <ResourceView onCreate={() => setView("createResource")}/>}
          {view === "createResource" && <CreateResource onBack={() => setView("resource")} />}
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginHorizontal: "auto",
    backgroundColor: colors.bg.light,
    width: "100%",
    maxWidth: 1200,
  },
  content: {
    flex: 1,
    flexDirection: "row",
  },
  item: {
    backgroundColor: colors.bg.medium,
    width: "100%",
    height: 50,
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    marginVertical: 5
  },
  itemText: {
    marginHorizontal: 'auto', fontSize: 16
  }
});
